import React, { useState, useEffect } from 'react';
import { Heart, UserCircle, Home, Users, MessageCircle } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { NAV_LINKS } from '../mock';
import AccountMenu from './AccountMenu';
import { getToken } from '../lib/auth';

const Navbar = ({ solid = false }) => {
  const [active, setActive] = useState('#home');
  const { pathname } = useLocation();
  const loggedIn = !!getToken();
  const toTop = () => window.scrollTo({ top: 0, left: 0, behavior: 'auto' });

  useEffect(() => {
    const onScroll = () => {
      const sections = ['home', 'how', 'why', 'stories', 'about', 'contact'];
      let current = '#home';
      sections.forEach((id) => {
        const el = document.getElementById(id);
        if (el && el.getBoundingClientRect().top <= 120) current = `#${id}`;
      });
      setActive(current);
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav className={(solid || loggedIn) ? 'nav-solid' : ''}>
      <div className="container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
        <Link to="/" className="brand" style={{ textDecoration: 'none' }}>
          <div className="logo">
            <Heart size={26} fill="#8E1638" color="#8E1638" />
            Krysha
          </div>
          <small>A Love Station With Your Vibe</small>
        </Link>
        <div className={`navlinks${loggedIn ? ' navlinks-auth' : ''}`}>
          {loggedIn ? (
            <>
              <Link to="/" onClick={toTop} className={pathname === '/' && active === '#home' ? 'active' : ''} data-testid="nav-home-link">
                <Home size={15} className="nav-ico" /><span className="lbl-full">Home</span><span className="lbl-short">Home</span>
              </Link>
              <a href="/#match" data-testid="nav-find-match-link">
                <Heart size={15} className="nav-ico" /><span className="lbl-full">Find My Match</span><span className="lbl-short">Match</span>
              </a>
              <Link to="/connect" onClick={toTop} className={pathname === '/connect' ? 'active' : ''} data-testid="nav-connect-link">
                <Users size={15} className="nav-ico" /><span className="lbl-full">Find Connection</span><span className="lbl-short">Connect</span>
              </Link>
              <Link to="/inbox" onClick={toTop} className={pathname === '/inbox' ? 'active' : ''} data-testid="nav-inbox-link">
                <MessageCircle size={15} className="nav-ico" /><span className="lbl-full">Inbox</span><span className="lbl-short">Inbox</span>
              </Link>
            </>
          ) : NAV_LINKS.map((l) => (
            <a key={l.href} href={`/${l.href}`} className={active === l.href ? 'active' : ''}>{l.label}</a>
          ))}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          {loggedIn ? (
            <AccountMenu />
          ) : (
            <>
              <Link to="/login" className="nav-account" data-testid="nav-account-link">
                <UserCircle size={17} /> Login
              </Link>
              <a className="btn btn-red" href="/#match">
                <Heart size={17} fill="#fff" /> Get My Match
              </a>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
